import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";
//Invoices
import InvoiceReducer from "./invoices/reducer";

// Authentication
import AssignedMembersReducer from "./assignedMembers/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";

// User Management Reducer Imports Start here
import organisationReducer from "./UserManagement/organisation/reducer";
import departmentReducer from "./UserManagement/department/reducer";
import teamReducer from "./UserManagement/team/reducer";
import userReducer from "./UserManagement/user/reducer";
import moduleReducer from "./UserManagement/module/reducer";
import userTypeReducer from "./UserManagement/UserType/reducer";

// User Management Reducer Imports End here

// Master Reducer Imports Start here

// Master Reducer Imports End here

import AccountReducer from "./auth/register/reducer";
import BlockReducer from "./block/reducer";
import CategoryReducer from "./Masters/category/reducer";
import CompanyReducer from "./Masters/company/reducer";
import CurrencyReducer from "./Masters/currency/reducer";
import DistrictReducer from "./district/reducer";
import EnquiryReducer from "./enquiry/reducer";
import GPReducer from "./gp/reducer";
import GST from "./Masters/gst/reducer";
import HSNCodeReducer from "./Masters/hsn-code/reducer";
import MakeReducer from "./Masters/make/reducer";
import ModelReducer from "./Masters/model/reducer";
import PackageReducer from "./package/reducer";
import ProductsAndServicesReducer from "./Masters/productsandservices/reducer";
import PaymentManagementReducer from "./paymentmanagement/reducer";
import ProductReducer from "./Masters/product/reducer";
import QuotationReducer from "./quotation/reducer";
import SACCodeReducer from "./Masters/sac-code/reducer";
import SalesOrderReducer from "./sales_order/reducer";
import SubCategoryReducer from "./Masters/sub-category/reducer";
import TypeReducer from "./Masters/type/reducer";
import UnitReducer from "./Masters/unit/reducer";
import TermsAndConditionReducer from "./Masters/terms-and-condition/reducer";
import SettingsReducer from "./Masters/settings/reducer";
import ChallanReducer from "./sales_order/challan/reducer";

import ItemReducer from "./item/reducer";
import PermissionReducer from "./permissions/reducer";
import districtinchargeReducer from "./SCH/district_incharge_mapping/reducer";
import CompletedTaskReducer from "./supervisor/task/completedTask/reducer";
import PendingTaskReducer from "./supervisor/task/pendingTask/reducer";

import usersTypeReducer from "./userstypes/reducer";
import configWarehouseReducer from "./Masters/warehosue/config.warehosue.reducer";
import warehouseReducer from "./Masters/warehosue/reducer";

import itemdistcitIchargeRequestReducer from "./DistrictIncharge/ItemRequest/reducer";
import FieldStockReducer from "./supervisor/fieldStock/reducer";
import InStockReducer from "./supervisor/stock/InStock/reducer";
import TransferHistoryReducer from "./supervisor/stock/transferHistory/reducer";
import ItemTaskReducer from "./supervisor/task/viewTask/item/reducer";
import MachinaryReducer from "./supervisor/task/viewTask/machinary/reducer";
import ManPowerReducer from "./supervisor/task/viewTask/manpower/reducer";
// inventory imports
import fieldEngineerFieldStockReducer from "./FieldEngineer/FieldStock/reducer";
import fieldEngineerInStockReducer from "./FieldEngineer/Stock/InStock/reducer";
import fieldEngineerTransferHistoryReducer from "./FieldEngineer/Stock/TransferHistory/reducer";
import fieldEngineerCompletedTaskReducer from "./FieldEngineer/Task/CompletedTask/reducer";
import fieldEngineerPendingTaskReducer from "./FieldEngineer/Task/PendingTask/reducer";
import inventoryDispatchReducer from "./Inventory/Dispatch/reducer";
import StockOverviewReducer from "./Inventory/Inventory/Stock_Overview/reducer";
import WarehouseStockSummaryReducer from "./Inventory/Inventory/Warehouse_Stock_Summary/reducer";
import WarehouseWiseStockReducer from "./Inventory/Inventory/Warehouse_Wise_Stock/reducer";
import itemRequestReducer from "./Inventory/ItemRequest/reducer";
import inventoryPackingReducer from "./Inventory/Packing/reducer";
import inventoryPurchaseOrderGRNReducer from "./Inventory/PurchaseOrder/PurchaseOrderGRN/reducer";
import inventoryPurchaseOrderReducer from "./Inventory/PurchaseOrder/reducer";
import InventoryStockTransferStateReducer from "./Inventory/StockTransferRequest/StockTransferRequestStockAllocationForm/reducer";
import {
  default as stockTransferlogInventoryReducer,
  default as StockTransferStockAllocationLogReducer,
} from "./Inventory/StockTransferRequest/StockTransferRequestStockAllocationLog/reducer";
import transferRequestReducer from "./Inventory/TransferRequest/reducer";
// procurement
import AReducer from "./Procurement/purchase-order/approved-pr/reducer";
import POreducer from "./Procurement/purchase-order/purchase-order/reducer";
import PRReducer from "./Procurement/purchase-request/reducer";
import draftRFQReducer from "./Procurement/rfq/DraftRFQ/reducer";
import rfqLogReducer from "./Procurement/rfq/RFQLog/reducer";
// Warehouse
import warehouseDropdownReducer from "./Dropdowns/Warehouse/WarehouseDropdown/reducer";
import WarehouseDispatchReducer from "./Warehouse/Dispatch/reducer";
import WarehouseGRNReducer from "./Warehouse/ItemInward/GRN/reducer";
import ReturnedAccessoriesInwardReducer from "./Warehouse/ItemInward/ReturnedAccessories/reducer";
import WarehousePendingPOReducer from "./Warehouse/ItemInward/PendingPO/reducer";
import WarehousePendingTransferReducer from "./Warehouse/ItemInward/PendingTransfer/reducer";
import WarehouseIssuePackingReducer from "./Warehouse/Packing/IssuePacking/reducer";
import WarehousePackingDoneReducer from "./Warehouse/Packing/PackingDone/reducer";
import DailyLogReducer from "./Warehouse/ProjectWarehouse/DailyLog/reducer";
import DamageReducer from "./Warehouse/ProjectWarehouse/Damage/reducer";
import damageItemsReducer from "./Warehouse/ProjectWarehouse/DamageItem/reducer";
import WarehouseInStockReducer from "./Warehouse/ProjectWarehouse/InStock/reducer";
import InStockItemsReducer from "./Warehouse/ProjectWarehouse/InStockItem/reducer";
import TransferRequestReducer from "./Warehouse/ProjectWarehouse/TransferRequest/reducer";

import WarehouseAllocationsReducer from "./Warehouse/Allocation/reducer";
import OandMwarehouseDailyLog from "./Warehouse/OandMwarehouse/DailyStock/reducer";
import OandMwarehouseFirstStock from "./Warehouse/OandMwarehouse/FRTStock/reducer";
import OandMwarehouseStcok from "./Warehouse/OandMwarehouse/Stock/reducer";
import PackingAllocationsDispatchReducer from "./warehousemasters/packing/reducer";

import StorageLocationReducer from "./DistrictIncharge/storageLocation/reducer";
import {
  default as inventoryItemRequestApprovalLogReducer,
  default as ItemRequestApprovalLogReducer,
} from "./Inventory/ItemRequest/ApprovalLog/reducer";
import InventoryItemRequestPendingReducer from "./Inventory/ItemRequest/PendingApproval/reducer";
import ItemRequestStockAllocationLogReducer from "./Inventory/ItemRequest/StockAllocationLog/reducer";
import recordLevelIteamWiseReducer from "./Inventory/ReorderLevel/InStock/reducer";
import WarehouseWiseReducer from "./Inventory/ReorderLevel/WarehouseWise/reducer";
import StockTransferApprovalLogReducer from "./Inventory/StockTransferRequest/StockTransferRequestApprovalLog/reducer";
import StockTransferPendingApprovalReducer from "./Inventory/StockTransferRequest/StockTransferRequestPendingApproval/reducer";
import inventoryStockOverviewSlice from "./Inventory/Instock/StockOverview/reducer";

// Project Manager
import ResourceRequestReducer from "./DistrictIncharge/resourceRequest/reducer";
import ProjectManageTaksAssignListReducer from "./SCH/AssignTasks/reducer";
import ProjectManagerDistrictInchargeMappingReducer from "./SCH/DistrictInchargeMapping/reducer";
import ProjectManagerMachineryReducer from "./SCH/Machinery/reducer";
import ProjectManagerMachineryAllocationReducer from "./SCH/MachineryAllocation/reducer";
import ProjectManagerManpowerReducer from "./SCH/Manpower/reducer";
import ProjectManagerManpowerAllocationReducer from "./SCH/ManpowerAllocation/reducer";
import ProjectManagerResourceRequestAllocationRequestReducer from "./SCH/ResourceRequest/AllocationRequest/reducer";
import ProjectManagerResourceRequestRequestLogReducer from "./SCH/ResourceRequest/RequestLog/reducer";
import ProjectManageTaksListReducer from "./SCH/Tasks/reducer";

// District Incharge
import DistrictInchargeDispatchReducer from "./DistrictIncharge/Dispatch/reducer";
import DistrictInchargeInstockReducer from "./DistrictIncharge/Inventory/InventoryListing/Instock/reducer";
import DistrictInchargeTransferRequestReducer from "./DistrictIncharge/Inventory/InventoryListing/TransferRequest/reducer";
import DistrictInChargeItemInwardReducer from "./DistrictIncharge/ItemInward/TaskListListing/GRN/reducer";
import DistrictInChargePendingDispatchReducer from "./DistrictIncharge/ItemInward/TaskListListing/PendingDispatch/reducer";
import fieldEngineerReducer from "./DistrictIncharge/MyTeams/MyTeamsListing/FieldEngineer/reducer";
import SupervisorReducer from "./DistrictIncharge/MyTeams/MyTeamsListing/Supervisor/reducer";
import DistrictInChargePackinggReducer from "./DistrictIncharge/Packing/PackingListing/IssuePacking/reducer";
import DistrictInchargeDonePackingReducer from "./DistrictIncharge/Packing/PackingListing/PackingDone/reducer";
import assignTaskReducer from "./DistrictIncharge/TaskList/TaskListListing/AssignedTask/reducer";
import TasksListPendingTaskReducer from "./DistrictIncharge/TaskList/TaskListListing/PendingTask/reducer";

import PackingIssuePackingReducer from "./DistrictIncharge/Packing/PackingListing/IssuePacking/reducer";
import PackingDoneReducer from "./DistrictIncharge/Packing/PackingListing/PackingDone/reducer";
import PackingDone from "./Warehouse/Packing/PackingDone/reducer";
import IssuePackingReducer from "./Warehouse/Packing/IssuePacking/reducer";
import inventorySupplierStockOverviewSlice from "./Inventory/Instock/SupplierStock/reducer";
// ===================================
import SupplierReducer from './Masters/supplier/reducer'
const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,

  // UserManagement Reducers Start here =================================
  Organisations: organisationReducer,
  department: departmentReducer,
  teams: teamReducer,
  users: userReducer,
  modules: moduleReducer,
  userType: userTypeReducer,
  // UserManagement Reducers End here ===================================

  // Master Reducers Start here

  // Master Reducers End here
  Invoice: InvoiceReducer,
  Package: PackageReducer,
  District: DistrictReducer,
  Block: BlockReducer,
  GP: GPReducer,
  Category: CategoryReducer,
  SubCategory: SubCategoryReducer,
  Type: TypeReducer,
  HSNCode: HSNCodeReducer,
  SACCode: SACCodeReducer,
  Currency: CurrencyReducer,
  Make: MakeReducer,
  Model: ModelReducer,
  Company: CompanyReducer,
  Unit: UnitReducer,
  GST: GST,
  TermsAndCondition: TermsAndConditionReducer,
  Settings: SettingsReducer,
  warehouse: warehouseReducer,
  Permission: PermissionReducer,
  ItemReducer: ItemReducer,
  // Inventory Reducers
  inventoryStockOverviewSlice,
  inventorySupplierStockOverviewSlice,
  StockOverviewReducer,
  WarehouseStockSummaryReducer,
  WarehouseWiseStock: WarehouseWiseStockReducer,
  recordLevelIteamWiseReducer,
  WarehouseWiseReducer,
  inventoryPurchaseOrderReducer,
  inventoryPurchaseOrderGRNReducer,
  ItemRequestApprovalLogReducer: ItemRequestApprovalLogReducer,
  transferRequestReducer,
  itemRequestReducer,
  inventoryPackingReducer,
  inventoryDispatchReducer,
  usersType: usersTypeReducer,
  configWarehouse: configWarehouseReducer,
  stockTransferlogInventory: stockTransferlogInventoryReducer,
  inventoryStockTransfer: InventoryStockTransferStateReducer,
  ProductsAndServices: ProductsAndServicesReducer,
  PaymentManagement: PaymentManagementReducer,
  Product: ProductReducer,
  Enquiry: EnquiryReducer,
  Quotation: QuotationReducer,
  SalesOrder: SalesOrderReducer,
  Challan: ChallanReducer,
  AssignedMembers: AssignedMembersReducer,
  //  usersType: usersTypeReducer,
  SupplierReducer: SupplierReducer,
  PendingTask: PendingTaskReducer,
  CompletedTask: CompletedTaskReducer,
  Item: ItemTaskReducer,
  Machinary: MachinaryReducer,
  ManPower: ManPowerReducer,
  InStock: InStockReducer,
  TransferHistory: TransferHistoryReducer,
  FieldStock: FieldStockReducer,
  districtincharge: districtinchargeReducer,
  // fieldEngineer
  FieldEngineerState: fieldEngineerReducer,
  SupervisorState: SupervisorReducer,
  fieldEngineerCompletedTaskReducer,
  fieldEngineerPendingTaskReducer,
  fieldEngineerInStockReducer,
  fieldEngineerTransferHistoryReducer,
  fieldEngineerFieldStockReducer,
  tasksPending: TasksListPendingTaskReducer,
  assignTask: assignTaskReducer,

  // procrement
  draftRFQReducer,
  rfqLogReducer,
  PRReducer: PRReducer,
  AReducer: AReducer,
  POreducer: POreducer,
  // warehouseAllocations: warehouseAllocationsReducer,
  packingAllocationsDispatch: PackingAllocationsDispatchReducer,

  // warehouseMasterReducer,

  // Warehouse
  DailyLog: DailyLogReducer,
  Damage: DamageReducer,
  damageItems: damageItemsReducer,
  WarehouseInStock: WarehouseInStockReducer,
  TransferRequest: TransferRequestReducer,
  WarehouseDispatchReducer: WarehouseDispatchReducer,
  warehouseGRN: WarehouseGRNReducer,
  returnedAccessoriesInward: ReturnedAccessoriesInwardReducer,
  WarehousePendingPO: WarehousePendingPOReducer,
  WarehousePendingTransferReducer,
  OandMwarehouseDailyLog: OandMwarehouseDailyLog,
  OandMwarehouseFirstStock: OandMwarehouseFirstStock,
  OandMwarehouseStcok: OandMwarehouseStcok,
  WarehouseIssuePackingReducer,
  WarehousePackingDoneReducer,
  PackingDone,
  IssuePackingReducer,
  inventoryItemRequestApprovalLog: inventoryItemRequestApprovalLogReducer,
  inventoryItemRequestPending: InventoryItemRequestPendingReducer,
  ItemRequestStockAllocationLogReducer,
  itemdistcitIchargeRequestReducer,
  StockTransferApprovalLogReducer,
  StockTransferPendingApprovalReducer,
  StockTransferStockAllocationLogReducer,
  WarehouseAllocationsReducer,
  // wahrehouse Dropdqowns
  warehouseDropdownReducer: warehouseDropdownReducer,
  inStockItems: InStockItemsReducer,

  // Project Manager
  ProjectManagerManpowerReducer: ProjectManagerManpowerReducer,
  ProjectManagerMachineryReducer: ProjectManagerMachineryReducer,
  ProjectManagerDistrictInchargeMappingReducer:
    ProjectManagerDistrictInchargeMappingReducer,
  ProjectManagerManpowerAllocationReducer:
    ProjectManagerManpowerAllocationReducer,
  ProjectManagerMachineryAllocationReducer:
    ProjectManagerMachineryAllocationReducer,
  ProjectManagerResourceRequestAllocationRequestReducer:
    ProjectManagerResourceRequestAllocationRequestReducer,
  ProjectManagerResourceRequestRequestLogReducer:
    ProjectManagerResourceRequestRequestLogReducer,
  projectManagerTaksList: ProjectManageTaksListReducer,
  projectManagerTaksAssignList: ProjectManageTaksAssignListReducer,

  //DistrictIncharge
  StorageLocation: StorageLocationReducer,
  ResourceRequest: ResourceRequestReducer,
  ItemInWardGRN: DistrictInChargeItemInwardReducer,
  DistrictInchargeInstockReducer: DistrictInchargeInstockReducer,
  DistrictInchargeTransferRequestReducer:
    DistrictInchargeTransferRequestReducer,
  DistrictInchargePacking: DistrictInChargePackinggReducer,
  DistrictInChargePendingDispatch: DistrictInChargePendingDispatchReducer,
  DistrictInchargeDonePacking: DistrictInchargeDonePackingReducer,
  DistrictInchargeDispatch: DistrictInchargeDispatchReducer,
  PackingIssuePackingReducer,
  PackingDoneReducer,
});
export default rootReducer;
